import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useState, useEffect } from 'react';

const adminNav = [
  { to: '/', label: 'Dashboard', icon: '📊', exact: true },
  { to: '/siparisler', label: 'Siparişler', icon: '🛒' },
  { to: '/siparisler/yeni', label: 'Yeni Sipariş', icon: '➕' },
  { to: '/arama', label: 'Arama', icon: '🔍' },
  { divider: true, label: 'ÜRÜN & DEPO' },
  { to: '/urunler', label: 'Ürünler', icon: '📦' },
  { to: '/depolar', label: 'Depolar & Stok', icon: '🏭' },
  { divider: true, label: 'MÜŞTERİ & SATIŞ' },
  { to: '/musteriler', label: 'Müşteriler', icon: '👥' },
  { to: '/komisyonlar', label: 'Komisyonlar', icon: '💰' },
  { to: '/odemeler', label: 'Ödemeler', icon: '💳' },
  { divider: true, label: 'RAPORLAR' },
  { to: '/raporlar', label: 'Raporlama', icon: '📈' },
  { divider: true, label: 'YÖNETİM' },
  { to: '/firmalar', label: 'Firmalar', icon: '🏢' },
  { to: '/kullanicilar', label: 'Kullanıcılar', icon: '⚙️' },
  { to: '/etken-maddeler', label: 'Etken Maddeler', icon: '🧪' },
  { to: '/kargo', label: 'Kargo Yönetimi', icon: '🚚' },
];

const temsilciNav = [
  { to: '/', label: 'Dashboard', icon: '📊', exact: true },
  { to: '/siparisler', label: 'Siparişlerim', icon: '🛒' },
  { to: '/siparisler/yeni', label: 'Yeni Sipariş', icon: '➕' },
  { to: '/musteriler', label: 'Müşterilerim', icon: '👥' },
  { to: '/komisyonlar', label: 'Komisyonlarım', icon: '💰' },
  { to: '/arama', label: 'Arama', icon: '🔍' },
];

const depocuNav = [
  { to: '/', label: 'Dashboard', icon: '📊', exact: true },
  { to: '/siparisler', label: 'Siparişler', icon: '🛒' },
  { to: '/depolar', label: 'Depolar', icon: '🏭' },
  { to: '/arama', label: 'Arama', icon: '🔍' },
];

// Mobil alt bar için kısa nav (max 5 item)
const mobilAdminNav = [
  { to: '/', label: 'Ana Sayfa', icon: '📊', exact: true },
  { to: '/siparisler', label: 'Siparişler', icon: '🛒' },
  { to: '/siparisler/yeni', label: 'Yeni', icon: '➕' },
  { to: '/musteriler', label: 'Müşteriler', icon: '👥' },
  { to: '/odemeler', label: 'Ödemeler', icon: '💳' },
];

const mobilTemsilciNav = [
  { to: '/', label: 'Ana Sayfa', icon: '📊', exact: true },
  { to: '/siparisler', label: 'Siparişler', icon: '🛒' },
  { to: '/siparisler/yeni', label: 'Yeni', icon: '➕' },
  { to: '/musteriler', label: 'Müşteriler', icon: '👥' },
  { to: '/komisyonlar', label: 'Komisyon', icon: '💰' },
];

const mobilDepocuNav = [
  { to: '/', label: 'Ana Sayfa', icon: '📊', exact: true },
  { to: '/siparisler', label: 'Siparişler', icon: '🛒' },
  { to: '/depolar', label: 'Depo', icon: '🏭' },
  { to: '/arama', label: 'Arama', icon: '🔍' },
];

export default function Layout() {
  const { profil, cikisYap } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handle = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handle);
    return () => window.removeEventListener('resize', handle);
  }, []);

  // Sayfa değişince sidebar'ı kapat (mobilde)
  useEffect(() => {
    if (isMobile) setSidebarOpen(false);
  }, [location.pathname]);

  async function handleCikis() {
    await cikisYap();
    navigate('/giris');
  }

  const rolLabel = { super_admin: 'Süper Admin', admin: 'Admin', temsilci: 'Temsilci', depocu: 'Depocu', goruntuleme: 'Görüntüleme' };

  let navItems = adminNav;
  let mobilNav = mobilAdminNav;
  if (profil?.rol === 'temsilci') { navItems = temsilciNav; mobilNav = mobilTemsilciNav; }
  else if (profil?.rol === 'depocu') { navItems = depocuNav; mobilNav = mobilDepocuNav; }

  return (
    <div style={{ display: 'flex', minHeight: '100vh', position: 'relative' }}>

      {/* MOBİL OVERLAY */}
      {isMobile && sidebarOpen && (
        <div onClick={() => setSidebarOpen(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 40 }} />
      )}

      {/* SIDEBAR */}
      <aside style={{
        width: 240,
        background: 'var(--bg2)',
        borderRight: '1px solid var(--border)',
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
        position: isMobile ? 'fixed' : 'relative',
        top: 0, left: 0, bottom: 0,
        zIndex: 50,
        transform: isMobile ? (sidebarOpen ? 'translateX(0)' : 'translateX(-100%)') : 'none',
        transition: 'transform 0.25s ease',
        overflowY: 'auto',
      }}>
        {/* Logo */}
        <div style={{ padding: '16px 16px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 10 }}>
          <img src="/logo.svg" alt="PisiPro" style={{ height: 26 }} onError={e => { e.target.style.display='none'; e.target.nextSibling.style.display='inline'; }} />
          <span style={{ fontWeight: 700, color: 'var(--accent)', fontSize: 16, display: 'none' }}>PisiPro</span>
          {isMobile && (
            <button onClick={() => setSidebarOpen(false)}
              style={{ marginLeft: 'auto', background: 'none', border: 'none', color: 'var(--text2)', fontSize: 20, cursor: 'pointer' }}>✕</button>
          )}
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, padding: '8px 0' }}>
          {navItems.map((item, i) => {
            if (item.divider) {
              return <div key={i} style={{ padding: '14px 16px 4px', fontSize: 10, fontWeight: 700, color: 'var(--text3)', letterSpacing: '1px', textTransform: 'uppercase' }}>{item.label}</div>;
            }
            return (
              <NavLink key={item.to} to={item.to} end={item.exact}
                style={({ isActive }) => ({
                  display: 'flex', alignItems: 'center', gap: 12, padding: '11px 16px',
                  color: isActive ? 'var(--accent)' : 'var(--text2)',
                  background: isActive ? 'rgba(224,123,0,0.1)' : 'transparent',
                  borderLeft: isActive ? '3px solid var(--accent)' : '3px solid transparent',
                  textDecoration: 'none', fontSize: 14, fontWeight: isActive ? 600 : 400,
                })}>
                <span style={{ fontSize: 18 }}>{item.icon}</span>
                {item.label}
              </NavLink>
            );
          })}
        </nav>

        {/* Kullanıcı & Çıkış */}
        <div style={{ padding: '12px 16px', borderTop: '1px solid var(--border)' }}>
          {profil && (
            <div style={{ marginBottom: 10 }}>
              <div style={{ fontSize: 13, fontWeight: 600 }}>{profil.ad} {profil.soyad}</div>
              <div style={{ fontSize: 11, color: 'var(--text3)' }}>{rolLabel[profil.rol]}</div>
            </div>
          )}
          <button onClick={handleCikis} className="btn btn-ghost btn-sm" style={{ width: '100%', justifyContent: 'center' }}>↩ Çıkış Yap</button>
        </div>
      </aside>

      {/* MAIN */}
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minWidth: 0 }}>
        {/* TOP BAR */}
        <div style={{ height: 54, background: 'var(--bg2)', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', padding: '0 16px', gap: 12, flexShrink: 0, position: 'sticky', top: 0, zIndex: 30 }}>
          <button onClick={() => setSidebarOpen(!sidebarOpen)}
            style={{ background: 'none', border: 'none', color: 'var(--text2)', cursor: 'pointer', fontSize: 22, padding: 4, lineHeight: 1 }}>☰</button>
          <img src="/logo.svg" alt="PisiPro" style={{ height: 24 }} onError={e => { e.target.style.display='none'; e.target.nextSibling.style.display='inline'; }} />
          <span style={{ fontWeight: 700, color: 'var(--accent)', fontSize: 15, display: 'none' }}>PisiPro</span>
          <div style={{ flex: 1 }} />
          {profil?.rol !== 'depocu' && (
            <NavLink to="/siparisler/yeni" className="btn btn-primary btn-sm" style={{ fontSize: 13 }}>+ Yeni Sipariş</NavLink>
          )}
        </div>

        {/* CONTENT */}
        <div style={{ flex: 1, overflow: 'auto', padding: isMobile ? '16px 12px 80px' : '24px', minWidth: 0 }}>
          <Outlet />
        </div>
      </main>

      {/* MOBİL ALT NAVİGASYON */}
      {isMobile && (
        <nav style={{
          position: 'fixed', bottom: 0, left: 0, right: 0,
          background: 'var(--bg2)', borderTop: '1px solid var(--border)',
          display: 'flex', zIndex: 35, height: 60,
        }}>
          {mobilNav.map(item => (
            <NavLink key={item.to} to={item.to} end={item.exact}
              style={({ isActive }) => ({
                flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
                justifyContent: 'center', gap: 2, textDecoration: 'none',
                color: isActive ? 'var(--accent)' : 'var(--text3)',
                background: isActive ? 'rgba(224,123,0,0.08)' : 'transparent',
                fontSize: 10, fontWeight: isActive ? 700 : 400,
                borderTop: isActive ? '2px solid var(--accent)' : '2px solid transparent',
              })}>
              <span style={{ fontSize: 20 }}>{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
          {/* Menü butonu */}
          <button onClick={() => setSidebarOpen(true)}
            style={{
              flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
              justifyContent: 'center', gap: 2, background: 'none', border: 'none',
              color: 'var(--text3)', fontSize: 10, cursor: 'pointer',
              borderTop: '2px solid transparent',
            }}>
            <span style={{ fontSize: 20 }}>☰</span>
            Menü
          </button>
        </nav>
      )}
    </div>
  );
}
